(function () {
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function safeText(s) {
    return (s || "").toString().replace(/\s+/g, " ").trim();
  }

  // remove upstream trailing ellipses so clamp doesn't create "double …"
  function stripTrailingEllipsis(s) {
    return safeText(s).replace(/(\.\.\.|…)\s*$/g, "").trim();
  }

  function formatCount(n) {
    if (!Number.isFinite(n)) return "";
    if (n >= 1000000) return (Math.round(n / 100000) / 10) + "M";
    if (n >= 1000) return (Math.round(n / 100) / 10) + "K";
    return String(n);
  }

  function starSVG(filled, accent) {
    return (
      '<svg class="tbr__star" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path fill="' + (filled ? accent : "rgba(14,14,14,.14)") + '" d="M12 17.27l-5.18 3.05 1.4-5.98L3 9.24l6.09-.52L12 3l2.91 5.72 6.09.52-5.22 5.1 1.4 5.98z"/>' +
      '</svg>'
    );
  }

  function renderStars(avg, accent) {
    if (!(typeof avg === "number" && isFinite(avg) && avg > 0)) return "";
    var a = Math.max(0, Math.min(5, avg));
    var out = '<span class="tbr__stars" aria-label="' + a.toFixed(1) + ' out of 5">';
    for (var i = 1; i <= 5; i++) out += starSVG(a >= i - 0.25, accent);
    out += "</span>";
    return out;
  }

  function buildAmazonSearch(title, author, tag) {
    var qy = encodeURIComponent((safeText(title) + " " + safeText(author)).trim());
    var t = encodeURIComponent((tag || "volarreoffici-20").trim() || "volarreoffici-20");
    return "https://www.amazon.com/s?k=" + qy + "&i=stripbooks&tag=" + t;
  }

  function buildAppleSearch(title, author) {
    var qy = encodeURIComponent((safeText(title) + " " + safeText(author)).trim());
    return "https://books.apple.com/us/search?term=" + qy;
  }

  // Hard-coded clean book icon for Apple button (prevents the "copy" glyph regression)
  var APPLE_BOOK_ICON =
    "<svg viewBox='0 0 24 24' aria-hidden='true'>" +
      "<path d='M6 3.5c-1.38 0-2.5 1.12-2.5 2.5v13c0 1.38 1.12 2.5 2.5 2.5H20v-2H6c-.28 0-.5-.22-.5-.5V6c0-.28.22-.5.5-.5h14V3.5H6z'/>" +
      "<path d='M20.5 3.5h-12C7.12 3.5 6 4.62 6 6v13.5c.33-.32.79-.5 1.3-.5H20.5V3.5z' opacity='.25'/>" +
    "</svg>";

  function initSection(root) {
    if (!root || root.__tbrInit) return;
    root.__tbrInit = true;

    var apiUrl = root.getAttribute("data-api-url") || "";
    var amazonTag = root.getAttribute("data-amazon-tag") || "volarreoffici-20";
    var accent = getComputedStyle(root).getPropertyValue("--tbr-accent").trim() || "#D0021B";

    var cartTpl = q(root, "template[data-tbr-cart]");
    var cartSVG = cartTpl ? cartTpl.innerHTML : "";

    // Tabs
    var tabsWrap = q(root, ".tbr__tabs");
    var tabs = qa(root, ".tbr__tab");
    var panels = qa(root, ".tbr__panel");

    function setTab(name) {
      if (tabsWrap) tabsWrap.setAttribute("data-active", name);
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-tab") === name;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-panel") === name);
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        setTab(t.getAttribute("data-tab"));
      });
    });

    // Trending rail
    var rail = q(root, '[data-rail="trending"]');
    var err = q(root, "[data-error]");
    var skeletonCards = qa(root, "[data-skeleton]");

    function removeSkeleton() {
      skeletonCards.forEach(function (n) { if (n && n.parentNode) n.parentNode.removeChild(n); });
    }

    function coverNode(src, title) {
      var well = document.createElement("div");
      well.className = "tbr__coverwell";

      if (src) {
        var img = document.createElement("img");
        img.className = "tbr__cover";
        img.loading = "lazy";
        img.alt = title || "Book cover";
        img.src = src;
        img.width = 320;
        img.height = 420;
        img.onerror = function () {
          var ph = document.createElement("div");
          ph.className = "tbr__cover tbr__cover--ph";
          ph.setAttribute("aria-hidden", "true");
          ph.innerHTML = "<span>V</span>";
          img.replaceWith(ph);
        };
        well.appendChild(img);
      } else {
        var ph2 = document.createElement("div");
        ph2.className = "tbr__cover tbr__cover--ph";
        ph2.setAttribute("aria-hidden", "true");
        ph2.innerHTML = "<span>V</span>";
        well.appendChild(ph2);
      }
      return well;
    }

    function ratingNode(rating) {
      var row = document.createElement("div");
      row.className = "tbr__ratingrow";

      var avg = rating && typeof rating.average === "number" ? rating.average : null;
      var cnt = rating && typeof rating.count === "number" ? rating.count : null;

      var starsHTML = renderStars(avg, accent);
      if (starsHTML) {
        row.innerHTML = starsHTML + (cnt ? ('<span class="tbr__rcount">' + formatCount(cnt) + '</span>') : "");
      } else {
        row.innerHTML = "";
      }
      return row;
    }

    function synopsisNode(previewRaw, fullRaw) {
      var wrap = document.createElement("div");
      wrap.className = "tbr__synwrap";

      var pv = stripTrailingEllipsis(previewRaw);
      var fu = safeText(fullRaw);

      var fallback = "Synopsis not available—tap Amazon for details.";
      var p = document.createElement("p");
      p.className = "tbr__synopsis tbr__synopsis--justify is-clamped";
      p.textContent = pv || fallback;
      wrap.appendChild(p);

      if (fu && (fu.length > (pv || "").length + 60)) {
        var btn = document.createElement("button");
        btn.className = "tbr__more";
        btn.type = "button";
        btn.setAttribute("aria-expanded", "false");
        btn.textContent = "READ MORE";

        btn.addEventListener("click", function () {
          var open = btn.getAttribute("aria-expanded") === "true";
          btn.setAttribute("aria-expanded", open ? "false" : "true");
          btn.textContent = open ? "READ MORE" : "CLOSE";

          if (!open) {
            p.classList.remove("is-clamped");
            p.classList.add("is-expanded");
            p.textContent = fu;
          } else {
            p.classList.remove("is-expanded");
            p.classList.add("is-clamped");
            p.textContent = pv || fallback;
          }
        });

        wrap.appendChild(btn);
      }

      return wrap;
    }

    function actionsNode(book) {
      var actions = document.createElement("div");
      actions.className = "tbr__actions";

      var amz = document.createElement("a");
      amz.className = "tbr__btn tbr__btn--primary";
      amz.href = buildAmazonSearch(book.title, book.author, amazonTag);
      amz.target = "_blank";
      amz.rel = "noopener";
      amz.innerHTML =
        '<span class="tbr__ico" aria-hidden="true">' + cartSVG + "</span>" +
        '<span class="tbr__label tbr__label--lg">AMAZON</span>' +
        '<span class="tbr__label tbr__label--sm">AMAZON</span>';

      var apl = document.createElement("a");
      apl.className = "tbr__btn tbr__btn--ghost";
      apl.href = buildAppleSearch(book.title, book.author);
      apl.target = "_blank";
      apl.rel = "noopener";
      apl.innerHTML =
        '<span class="tbr__ico" aria-hidden="true">' + APPLE_BOOK_ICON + "</span>" +
        '<span class="tbr__label tbr__label--lg">APPLE BOOKS</span>' +
        '<span class="tbr__label tbr__label--sm">APPLE</span>';

      actions.appendChild(amz);
      actions.appendChild(apl);
      return actions;
    }

    function card(book) {
      var c = document.createElement("article");
      c.className = "tbr__card";

      var media = document.createElement("div");
      media.className = "tbr__media";
      media.appendChild(coverNode(book.cover, book.title));
      c.appendChild(media);

      var body = document.createElement("div");
      body.className = "tbr__body";

      var top = document.createElement("div");
      top.className = "tbr__topline";

      var rank = document.createElement("span");
      rank.className = "tbr__rank";
      rank.textContent = "#" + (book.rank || "");
      top.appendChild(rank);

      var pill = document.createElement("span");
      pill.className = "tbr__pill";
      pill.textContent = (book.tag || "TRENDING");
      top.appendChild(pill);

      body.appendChild(top);

      var h = document.createElement("h3");
      h.className = "tbr__book";
      h.textContent = safeText(book.title).toUpperCase();
      body.appendChild(h);

      var a = document.createElement("p");
      a.className = "tbr__author";
      a.textContent = safeText(book.author);
      body.appendChild(a);

      body.appendChild(ratingNode(book.rating || null));

      body.appendChild(synopsisNode(book.description, book.description_full));

      body.appendChild(actionsNode(book));
      c.appendChild(body);

      return c;
    }

    fetch(apiUrl, { method: "GET" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.ok !== true || !Array.isArray(data.books) || !data.books.length) {
          throw new Error("No books returned");
        }

        removeSkeleton();
        if (err) err.hidden = true;

        while (rail.firstChild) rail.removeChild(rail.firstChild);
        data.books.forEach(function (b) { rail.appendChild(card(b)); });
      })
      .catch(function () {
        removeSkeleton();
        if (err) err.hidden = false;
      });
  }

  function boot() {
    document.querySelectorAll(".tbr").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();